import { PlusOutlined } from "@ant-design/icons";
import { Button, Modal } from "antd";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import Footer from "../../../components/Footer";
import NavBar from "../../../components/NavBar";
import SideBar from "../../../components/SideBar"; // ✅ NatureActe.jsx (actions visibles sans dropdown)

import AddNatureActe from "./AddNatureActe";
import ActionDropdown from "../../production/components/ActionDropdown";
import axiosInstance from "../../../variables/api/axiosInstance";

const NatureActe = () => {
  const [natureActes, setNatureActes] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [selectedNatureActe, setSelectedNatureActe] = useState(null);

  useEffect(() => {
    fetchNatureActes();
  }, []);

  const fetchNatureActes = () => {
    axiosInstance
      .get(`/api/parametre/type/NATURE_ACTE`)
      .then((res) => {
        const sorted = res.data.sort((a, b) => b.parametreId - a.parametreId);
        setNatureActes(sorted);
      })
      .catch((err) => console.error("Erreur récupération natures actes:", err));
  };

  const handleShow = (edit = false, natureActe = null) => {
    setShowModal(true);
    setEditMode(edit);
    setSelectedNatureActe(natureActe);
  };

  const handleClose = () => {
    setShowModal(false);
    setEditMode(false);
    setSelectedNatureActe(null);
  };

  const handleAdd = (newNatureActe) => {
    setNatureActes((prev) => [newNatureActe, ...prev]);
  };

  const handleUpdate = (updatedNatureActe) => {
    setNatureActes((prev) =>
      prev.map((n) =>
        n.parametreId === updatedNatureActe.parametreId ? updatedNatureActe : n
      )
    );
  };

  const handleDeleteNatureActe = (natureActeId) => {
    Modal.confirm({
      title: "Êtes-vous sûr de vouloir supprimer cette nature de l'acte ?",
      content: "Cette action est irréversible",
      okText: "Oui",
      okType: "danger",
      cancelText: "Annuler",
      onOk: () => {
        axiosInstance
          .delete(`/api/parametre/${natureActeId}`)
          .then(() => {
            setNatureActes((prev) =>
              prev.filter((n) => n.parametreId !== natureActeId)
            );
            toast.success("Nature de l'acte supprimée avec succès.");
          })
          .catch((err) => {
            console.error("Erreur suppression nature acte:", err);
            toast.error(
              "Erreur lors de la suppression de la nature de l'acte."
            );
          });
      },
    });
  };

  return (
    <div className="layout-wrapper layout-content-navbar">
      <div className="layout-container">
        <SideBar currentMenu="PARAMETRES_SINISTRES" />
        <div className="layout-page">
          <NavBar />
          <div className="content-wrapper">
            <div className="container-xxl flex-grow-1 container-p-y">
              <Button
                type="primary"
                icon={<PlusOutlined />}
                style={{ marginBottom: 16 }}
                onClick={() => handleShow()}
              >
                Ajouter une nouvelle nature de l'acte
              </Button>
              <div className="card">
                <h5 className="card-header">Paramétrage des natures d'actes</h5>
                <div className="table-responsive text-nowrap">
                  <table className="table">
                    <thead>
                      <tr>
                        <th>Libellé</th>
                        <th>Type</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody className="table-border-bottom-0">
                      {natureActes?.map((natureActe, id) => (
                        <tr key={id}>
                          <td>{natureActe.libelleParametre}</td>
                          <td>{natureActe.type || ""}</td>
                          <td>
                            <ActionDropdown
                              actions={[
                                {
                                  key: "edit",
                                  label: "Modifier",
                                  icon: <i className="bx bx-edit-alt" />,
                                  onClick: () => handleShow(true, natureActe),
                                },
                                {
                                  key: "delete",
                                  label: "Supprimer",
                                  icon: <i className="bx bx-trash" />,
                                  danger: true,
                                  onClick: () =>
                                    handleDeleteNatureActe(
                                      natureActe.parametreId
                                    ),
                                },
                              ]}
                            />
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <Footer />
          </div>
        </div>
      </div>

      <AddNatureActe
        show={showModal}
        handleClose={handleClose}
        editMode={editMode}
        selectedNatureActe={selectedNatureActe}
        natureActes={natureActes}
        onAdd={handleAdd}
        onUpdate={handleUpdate}
      />
    </div>
  );
};

export default NatureActe;
